import gql from "graphql-tag";

export const createAdminRoleMutation = gql`
  mutation(
    $id: Int
    $name: String!
    $description: String
    $privileges: [Int]!
  ) {
    createAdminRole(
      id: $id
      name: $name
      description: $description
      privileges: $privileges
    ) {
      status
      errorMessage
    }
  }
`;

export const deleteAdminRoleMutation = gql`
  mutation($id: Int!) {
    deleteAdminRole(id: $id) {
      status
      errorMessage
    }
  }
`;

export const getPrivilegesQuery = gql`
  query {
    getPrivileges {
      results {
        id
        name
        permittedUrls
      }

      status
      errorMessage
    }
  }
`;

export const createAdminUserMutation = gql`
  mutation($id: String, $email: String!, $password: String, $roleId: Int!) {
    createAdminUser(
      id: $id
      email: $email
      password: $password
      roleId: $roleId
    ) {
      status
      errorMessage
    }
  }
`;

export const deleteAdminUserMutation = gql`
  mutation($id: String!) {
    deleteAdminUser(id: $id) {
      status
      errorMessage
    }
  }
`;

export const getAdminUserQuery = gql`
  query {
    getAdminUser {
      result {
        id
        email
        isSuperAdmin
        roleId
        createdAt
        updatedAt
        adminRole {
          id
          privileges
        }
      }
      status
      errorMessage
    }
  }
`;

export const adminUserLoginQuery = gql`
  query($email: String!, $password: String!) {
    adminUserLogin(email: $email, password: $password) {
      status
      token
      isSuperAdmin
      errorMessage
    }
  }
`;

export const updateConfigSettingsMutation = gql`
  mutation updateConfigSettings(
    $smtpHost: String
    $smtpPort: String
    $smptEmail: String
    $smtpSender: String
    $smtpSenderEmail: String
    $smtpPassWord: String
    $maxUploadSize: String
    $stripePublishableKey: String
    $fcmPushNotificationKey: String
  ) {
    updateConfigSettings(
      smtpHost: $smtpHost
      smtpPort: $smtpPort
      smptEmail: $smptEmail
      smtpSender: $smtpSender
      smtpSenderEmail: $smtpSenderEmail
      smtpPassWord: $smtpPassWord
      maxUploadSize: $maxUploadSize
      stripePublishableKey: $stripePublishableKey
      fcmPushNotificationKey: $fcmPushNotificationKey
    ) {
      status
      errorMessage
    }
  }
`;

export const adminUserLogoutQuery = gql`
  query {
    adminUserLogout {
      status
    }
  }
`;
